/**
 * Universal AI Block - Frontend
 * Dynamically loads the selected component
 */
import React from "react";
import { createRoot } from "react-dom/client";
import { BlockContext } from "@components/BlockContext";
import { loadComponent } from "./components-index.js";

// The editor's stage intro groups (block attributes form* / topics* /
// angles*), in stage order; a component shows one with `<StageIntro stage={N} />`.
const STAGE_ATTRIBUTE_KEYS = ["form", "topics", "angles"];

const readIntros = (dataset) =>
	STAGE_ATTRIBUTE_KEYS.map((key) => ({
		eyebrow: dataset[`${key}IntroEyebrow`] || "",
		heading: dataset[`${key}IntroHeading`] || "",
		text: dataset[`${key}IntroText`] || "",
		footer: dataset[`${key}IntroFooter`] || "",
	}));

document.addEventListener("DOMContentLoaded", function () {
	const containers = document.querySelectorAll("#nm-universal-ai-block");

	containers.forEach(async (container) => {
		const blockId = container.dataset.blockId;
		const componentName = container.dataset.component;
		const isLoggedIn = container.dataset.isLoggedIn === "true";
		const canUseAiAgain = container.dataset.canUseAiAgain === "true";
		const mockupMode = container.dataset.mockupMode === "true";
		const intros = readIntros(container.dataset);

		try {
			const ComponentClass = await loadComponent(componentName);

			if (ComponentClass) {
				const root = createRoot(container);
				root.render(
					<BlockContext.Provider value={{ mockupMode, intros }}>
						<ComponentClass
							blockId={blockId}
							isLoggedIn={isLoggedIn}
							ajaxObject={nm_ajax_object}
							componentName={componentName}
							canUseAiAgain={canUseAiAgain}
							mockupMode={mockupMode}
						/>
					</BlockContext.Provider>,
				);
			} else {
				renderFallback(container, componentName);
			}
		} catch (error) {
			console.error(`Failed to load component ${componentName}:`, error);
			renderFallback(container, componentName);
		}
	});
});

function renderFallback(container, componentName) {
	container.innerHTML = `
        <div style="padding: 20px; text-align: center; border: 1px solid #ddd; border-radius: 8px;">
            <p>⚠️ Component "${componentName}" could not be loaded.</p>
        </div>
    `;
}
